import React from "react";
import { MdSecurity } from "react-icons/md";
import linhaimg from "../../assets/linha/linem.png";

function MonitoredEnvironment() {
  return (
    <>
      <div className="flex flex-nowrap   justify-center w-full overflow-hidden">
        {[...Array(20)].map((_, index) => (
          <img
            key={index}
            src={linhaimg}
            alt="Linha Versace"
            className="w-28 h-auto opacity-90"
          />
        ))}
      </div>
      <div className=" flex justify-center items-center bg-[#e4e0e0]  ">
        <div className="flex items-center  ">
          <div className="text-4xl text-white mr-5">
            <MdSecurity className="animate-pulse text-slate-700" />
          </div>

          <h1 className="text-[13px] text-slate-700  my-2">
            <marquee direction="left" behavior="scroll" scrollamount="5">
              Atenção! Este ambiente é monitorado de forma constante. A partir
              deste momento, todas as suas ações dentro da plataforma estão
              sendo cuidadosamente acompanhadas!
            </marquee>
          </h1>
        </div>
      </div>
      <div className="flex flex-nowrap   justify-center w-full overflow-hidden">
        {[...Array(20)].map((_, index) => (
          <img
            key={index}
            src={linhaimg}
            alt="Linha Versace"
            className="w-28 h-auto opacity-90"
          />
        ))}
      </div>
    </>
  );
}

export default MonitoredEnvironment;
